import { apiSpiderMapBaseURL, apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const drawApiRoutes = {
    generate: apiSpiderMapBaseURL + "draw/",
    list: apiSpiderMapBaseURL + "draw/list/",
    delete: apiFilesBaseURL + "files/delete/spidermap/",
};

export class DrawAPI {
    static generate(model) {
        const url = `${drawApiRoutes.generate}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }
    
    static list() {
        const url = `${drawApiRoutes.list}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static delete(fileName) {
        const url = `${drawApiRoutes.delete}${fileName}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
